import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Contact from "./components/Contact";
import Timeline from "./components/Timeline";
import Skills from "./components/SkillPart/Skills";
import { CertificatePart } from "./components/CertificatePart/CertificatePart";
import Repositories from "./components/WorkPart/Repositories";

function App() {
  return (
    <div>
      <Navbar />
      <div className="h-36"></div>
      <Hero />
      <Skills />
      <About />
      <Repositories />
      <CertificatePart />
      <Timeline />
      <Contact />
    </div>
  );
}

export default App;
